var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.1055 3.97535V5.56545H11.9254V3.97535H15.1055ZM7.15506 3.97535V8.74565H3.97486V3.97535H7.15506ZM15.1055 10.3357V15.106H11.9254V10.3357H15.1055ZM7.15506 13.5159V15.106H3.97486V13.5159H7.15506ZM16.6956 2.38525H10.3353V7.15555H16.6956V2.38525ZM8.74516 2.38525H2.38477V10.3357H8.74516V2.38525ZM16.6956 8.74565H10.3353V16.6961H16.6956V8.74565ZM8.74516 11.9258H2.38477V16.6961H8.74516V11.9258Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.5c2923a0.svg";
export { ForwardRef as ReactComponent };